var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    fill: "none",
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.282,
    d: "M10.497 20.389h0l1.865-6h.421c.298 0 .572-.123.754-.33l10.413 4.268s0 0 0 0c.127.053.26.08.397.08.183 0 .365-.048.53-.143h0l.003-.002c.277-.166.45-.46.45-.774V1.18c-.007-.312-.177-.605-.455-.772-.276-.165-.625-.192-.924-.069L13.536 4.598c-.179-.204-.45-.343-.753-.343H6.219C3.23 4.255.781 6.528.781 9.326c0 2.39 1.786 4.395 4.163 4.934v5.87c0 .518.447.933.983.933h3.628c.437 0 .82-.282.942-.674zm3.244-8.248V6.525l5.757-2.343v10.3L13.74 12.14zM2.747 9.32c0-1.763 1.545-3.219 3.472-3.219h5.556v6.439H6.22c-1.922 0-3.472-1.456-3.472-3.22zm7.567 5.067l-1.496 4.827H6.91v-4.827h3.404zm11.15-11.007l1.895-.785v13.479l-1.896-.785V3.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement-icon.03a7c34b0d5a0fdd4acae5d0df539ee6.svg";
export { ForwardRef as ReactComponent };